export const config = {
    redirectUrl: 'http://localhost:8080/#/home',
    appId: '57d8dfae99b222d97cc48a5d969ad395',
    loginUrl: 'http://127.0.0.1:8080/#/login',
    authBaseUrl: 'http://172.100.3.94/serv/oauth'
}
